export default class MassiaSelectSupervisorService {
	static $inject = ['$http', 'SharedDataService', 'notification'];

	constructor($http, SharedDataService, notification) {
		this.$http = $http;
		this.SharedDataService = SharedDataService;
		this.notification = notification;
		this.controllers = [];
		this.started = false;
		this.unsubscribe = null;
	}

	start() {
		this.started = true;

		//Attente de tous les controllers avant de continuer
		this.waitForMassiaReady().then(() => {
			this.isWaiting = false;
			this.isError = false;
			//garde fou
			if (this.controllers.length === 0) return;

			//On envoie l'état initial à tous les controllers
			this.controllers.forEach((c) => {
				c.supervisorWaiting = false;
				c.supervisorError = false;
				if (c.firstLoad) {
					//On prévient le controller qu'on est prêt et que les données initiales peuvent être chargées
					c.firstLoad();
				}
			});
			this.unsubscribe = this.SharedDataService.subscribe((key, value) => {
				// Propager le changement à tous les MassiaSelect concernés
				this.controllers.forEach((c) => {
					console.log('🚀 ~ MassiaSelectSupervisorService ~ start ~ c:', c);
					const dataLinkExists = c.paramConfigMap ? Object.values(c.paramConfigMap).some((v) => v.datalink === key) : false;

					//On dit aux controllers qui ont un datalink correspondant que les params ont changé (pour recharger les données si besoin)
					if (dataLinkExists) {
						if (c.checkParamsAndLoad) {
							c.checkParamsAndLoad();
						}
					}

					//Validation du formulaire, chaque controller se met à jour (erreur ou autre)
					if (c.name == key && c.verifyForm) {
						c.verifyForm(value);
					}
				});
			});
		});
	}

	waitForMassiaReady() {
		this.isWaiting = true;
		this.controllers.forEach((c) => {
			c.supervisorWaiting = true;
		});

		// Timeout de 15 secondes pour éviter une attente infinie en cas de problème d'initialisation
		const timeout = new Promise(() =>
			setTimeout(() => {
				const pending = this.controllers.filter((c) => !c.initComplete).map((c) => c.name ?? c.constructor.name);
				if (pending.length > 0) {
					this.controllers.forEach((c) => {
						c.supervisorWaiting = false;
						c.supervisorError = true;
					});
					//Popup et log des controllers non prêts
					console.error(`[Supervisor] Timeout — controllers non prêts : ${pending.join(', ')}`);
					this.notification.error("Erreur d'initialisation d'un controller. Voir la console.");
					this.isError = true;
					this.isWaiting = false;
				}
			}, 15000)
		);

		let resolve;
		const allReady = new Promise((r) => {
			resolve = r;
		});

		// _onControllerReady est stocké sur this pour permettre l'ajout de controllers pendant l'attente
		this._onControllerReady = () => {
			if (this.controllers.every((c) => c.initComplete)) {
				resolve();
			}
		};

		// Chaque controller notifie le supervisor de son état prêt via readyPromise
		this.controllers.forEach((c) => c.readyPromise.then(this._onControllerReady));

		return Promise.race([allReady, timeout]);
	}

	addController(item) {
		if (item) {
			this.controllers.push(item);
		}
		if (!this.started) {
			this.started = true;
			setTimeout(() => this.start(), 0);
		} else if (this.isWaiting) {
			// Supervisor toujours en attente : inclure le nouveau controller dans le check live
			item.supervisorWaiting = true;
			item.supervisorError = false;
			item.readyPromise.then(this._onControllerReady);
		} else {
			// Supervisor déjà terminé : déclencher firstLoad indépendamment pour ce controller
			item.supervisorError = this.isError;
			item.supervisorWaiting = false;
			if (!this.isError && item.firstLoad) {
				item.readyPromise.then(() => {
					item.supervisorWaiting = false;
					item.supervisorError = false;
					item.firstLoad();
				});
			}
		}
	}

	removeController(item) {
		if (item) {
			const index = this.controllers.indexOf(item);
			if (index > -1) {
				this.controllers.splice(index, 1);
			}

			if (this.controllers.length === 0 && this.unsubscribe) {
				this.unsubscribe();
				this.started = false;
			}
		}
	}

	watchParams() {
		this.$scope.$watchGroup(
			// 🔍 On observe chaque champ lié
			this.paramKeys.map((k) => {
				const cfg = this.paramConfigMap[k];
				const datalinkName = cfg.datalink;

				return () => {
					const d = this.SharedDataService.getData(datalinkName);
					return d ? d.value : '';
				};
			}),

			async (newVals, oldVals) => {
				console.log('1 watchParams➜', this.name, newVals, oldVals, this.ngModel);
				// ➜ Pas de changement réel
				if (angular.equals(newVals, oldVals)) return;
			}
		);
	}
}
